import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Tag } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class TagService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getTag(id): Promise<Tag> {
    return new Tag(
      await this.core.services.tag.getById(id, {
        id: null,
        name: null,
        type: null,
        color: null,
        externalId: null,
      })
    )
  }

  async getTags(
    parameters: any = {},
    schema: any = { id: null, name: null, type: null }
  ): Promise<{
    // items: (Partial<Tag> | Tag)[],
    items: Tag[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.tag.getList(parameters, schema)
  }

  createTag(tag: any, schema: any): Promise<Tag> {
    return this.core.services.tag.create(tag, schema)
  }

  async updateTag(tag: any, schema: any): Promise<Tag> {
    return await this.core.services.tag.update(tag, schema)
  }

  deleteTag(tag: Partial<Tag>): Promise<Tag> {
    return this.core.services.tag.delete(tag)
  }

  async getTypes(
    parameters: any = {},
    schema: any = { id: null }
  ): Promise<{
    items: [{ id: null }]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.tag.getTypes(parameters, schema)
  }
}
